import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiImageSize, FileType, ObjectTypes } from '@fi-shared/types';
import { LinkToModel } from '@fi-shared/link-to/link-to.model';
import { FileUploadModel } from '@fi-app/utilities/file-upload/file-upload.model';
import { FiFileUpload2Service } from '@fi-shared/fi-insert-media/fi-file-upload2.service';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { IDocumentLayoutImageModel } from '@fi-app/document/document-layout/layout-item-image/image-column/image-column.component';

@Component({
    selector: 'fi-document-template-edit-image',
    templateUrl: './image.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./image.component.scss'],
    host: { class: 'fi-document-template-edit-image' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: DocumentTemplateEditItemImageComponent,
        },
    ],
    standalone: false,
})
export class DocumentTemplateEditItemImageComponent implements OnInit, OnDestroy {
    // todo add typings
    @Input() ngModel: IDocumentLayoutImageModel;
    //@Input() mediaReferences: IMediaBankFileReference[];
    @Output('fileChange') fileChangeEmitter: EventEmitter<{ newId; oldId }> = new EventEmitter();
    propagateChange = (_: any) => {};

    fileUploadModel: FileUploadModel;
    selectedFiles = [];

    constructor(
        private fiLoadingService: LoadingService,
        private mediaStorageService: FiMediaStorageService,
        private fileUploadService: FiFileUpload2Service,
    ) {}

    writeValue(obj: any) {
        this.ngModel = obj;
    }

    registerOnChange(fn: any) {
        this.propagateChange = fn;
    }

    // note: not used ?
    registerOnTouched(fn: any) {}

    ngOnInit() {
        if (!(this.ngModel.linkTo instanceof LinkToModel)) this.ngModel.linkTo = new LinkToModel(this.ngModel.linkTo);

        const initModelFromFile = (mediaBankFileReference: IMediaBankFileReference) => {
            this.setViewValue(<IDocumentLayoutImageModel>{
                MediaBankFileId: mediaBankFileReference.MediaBankFileId,
                Url: this.mediaStorageService.getMediaFileUrl(mediaBankFileReference, { size: FiImageSize.Medium }),
                Name: mediaBankFileReference.Name,
                PhysicalFileName: mediaBankFileReference.PhysicalFileName,
                Extension: mediaBankFileReference.Extension,
                FileType: mediaBankFileReference.FileType,
                StorageType: mediaBankFileReference.StorageType,
                ChangedOn: mediaBankFileReference.ChangedOn,
                IsNewUpload: mediaBankFileReference.IsNewUpload,
                HideFromMediaBank: mediaBankFileReference.HideFromMediaBank,
            });
        };

        this.fileUploadModel = new FileUploadModel(($files) => {
            if ($files.length == 0) return false;

            this.selectedFiles = [];
            this.fiLoadingService.trackPromise(
                this.fileUploadService.silentUploadFiles($files).then((mediaBankFileReferences) => {
                    initModelFromFile(mediaBankFileReferences[0]);
                }),
            );
        });
        this.fileUploadModel.accept = 'image/*,video/mp4';
        this.fileUploadModel.DropFilesTextId = 'ccmFileUpload.dropFilesSingle';

        this.fileUploadModel.setBrowseMediaBankDone(ObjectTypes.Template, (mediaBankFileReferences) => {
            initModelFromFile(mediaBankFileReferences[0]);
        });
    }

    ClearImage() {
        this.setViewValue({
            MediaBankFileId: null,
            Url: null,
            Name: null,
            PhysicalFileName: null,
            Extension: null,
            FileType: null,
            StorageType: null,
            IsNewUpload: null,
            HideFromMediaBank: null,
        });
        this.selectedFiles = [];
    }

    GetUrl() {
        // note: find in empty array?
        const existingReference = [].find((item) => item.MediaBankFileId === this.ngModel.MediaBankFileId);
        return this.mediaStorageService.getMediaFileUrl(existingReference ? existingReference : this.ngModel, {
            size: FiImageSize.Medium,
        });
    }

    ngOnDestroy() {
        if (this.ngModel && this.ngModel.linkTo && !this.ngModel.linkTo.Value) delete this.ngModel.linkTo;
    }

    isVideo() {
        return this.ngModel.FileType == FileType.Movie;
    }

    setViewValue(data) {
        const fileChangeEvent = { newId: data.MediaBankFileId, oldId: this.ngModel.MediaBankFileId };
        this.ngModel = Object.assign({}, this.ngModel, data);
        this.propagateChange(this.ngModel);
        this.fileChangeEmitter.emit(fileChangeEvent);
    }

    isExistingImage() {
        return this.ngModel && this.GetUrl();
    }

    deleteFile(file) {
        setTimeout(() => this.ClearImage());
    }

    isVimeoStorage() {
        return this.mediaStorageService.isVimeoStorage(this.ngModel.StorageType);
    }
}
